import { EnrollmentProposition } from '../../lib/types/models/enrollment-proposition/enrollment-proposition'
import { EnrollmentPropositionRequest } from '../../lib/types/models/enrollment-proposition/enrollment-proposition-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createEnrollmentProposition(data: IdInput<EnrollmentPropositionRequest>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.enrollments.createProposition.url, { id }))
    .post<EnrollmentProposition, EnrollmentPropositionRequest>(rest)
}
